import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "spinnerContainer" }
const _hoisted_2 = {
  key: 0,
  class: "appMode"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_4 = { class: "sideMenu d-flex flex-column p-3" }
const _hoisted_5 = { class: "navContainer flex-grow-1 gap-1" }
const _hoisted_6 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_box_arrow_right = _resolveComponent("icon-box-arrow-right")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_op_modal_container = _resolveComponent("op-modal-container")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "appContainer",
    onDragenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setHightlights && _ctx.setHightlights(...args))),
    onDragover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setHightlights && _ctx.setHightlights(...args))),
    onDragend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsetHighlights && _ctx.unsetHighlights(...args))),
    onDrop: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.unsetHighlights && _ctx.unsetHighlights(...args)))
  }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, _cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "spinner" }, [
            _createElementVNode("div"),
            _createElementVNode("div"),
            _createElementVNode("div"),
            _createElementVNode("div")
          ], -1)
        ]), 512), [
          [_vShow, _ctx.showSpinner]
        ])
      ]),
      _: 1
    }),
    (_ctx.showApp)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.appMode != 'production')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Modalità: " + _toDisplayString(_ctx.appMode), 1))
            : _createCommentVNode("", true),
          (_ctx.showMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("nav", _hoisted_4, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "fw-bold text-primary mb-4 px-2" }, "Backoffice", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: item.path,
                        to: item.path,
                        class: _normalizeClass(["sideNav text-decoration-none", { active: _ctx.isActive(item.path) }])
                      }, {
                        default: _withCtx(() => [
                          (item.icon)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                key: 0,
                                class: "me-2"
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"]))
                    }), 128))
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, [
                    _createVNode(_component_icon_box_arrow_right, { class: "me-2" }),
                    _cache[6] || (_cache[6] = _createTextVNode(" Esci "))
                  ])
                ]),
                _createElementVNode("main", _hoisted_6, [
                  _createVNode(_component_router_view)
                ])
              ]))
            : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_op_modal_container)
  ], 544))
}